import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { Field, useFormik, FormikProvider } from "formik";
import HousingService from "../../Services/HousingService";
import { useHistory } from "react-router-dom";
import NavigationServicesHeader from "../../Header/NavigationServicesHeader";
import { Form, FormGroup, Col } from "react-bootstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { Link } from "react-router-dom";
import $ from "jquery";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment-timezone";
import jsPDF from "jspdf";
import { FaFastBackward, FaFileExcel } from "react-icons/fa";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { store } from "../../App";
import { GetDetails, ModuleHeader } from "../utils/commonFunctions";

const NpiPhysicalProgressReport = () => {
  let history = useHistory();
  const [distList, setDistList] = useState();
  const [divisionList, setDivisionList] = useState();
  const [constituencyList, setConstituencyList] = useState();
  const [mandalList, setMandalList] = useState();
  const [secretariatList, setSecretariatList] = useState();
  const [contractorList, setContractorList] = useState();
  const [layoutList, setLayoutList] = useState();
  const [divEn, setDivEn] = useState(false);
  const [constEn, setconstEn] = useState(false);
  const [mandalEn, setmandalEn] = useState(false);
  const [secEn, setSecEn] = useState(false);
  const [contEnb, setcontEnb] = useState(false);
  const [layenb, setlayEnb] = useState(false);
  const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [tableDistEn, setTableDistEn] = useState(true);
  const [tableDivEn, setTableDivEn] = useState(false);
  const [tableConstEn, setTableConstEn] = useState(false);
  const [tableMandEn, setTableMandEn] = useState(false);
  const [tableSecEn, setTableSecEn] = useState(false);
  const [tableContrEn, setTableContrEn] = useState(false);
  const [tableLayoutEn, setTablelayoutEn] = useState(false);
  const [details, setDetails] = useState();
  const [paymentTable, setPaymentTable] = useState(true);
  const [benTable, setBenTable] = useState(false);
  const [distname, setdistname] = useState("All");
  const [divname, setDivname] = useState("All");
  const [constname, setConstname] = useState("All");
  const [mandalname, setMandalname] = useState("All");
  const [secname, setSecname] = useState("All");
  const [contractname, setContractname] = useState("All");
  const [layoutname, setLayoutname] = useState("All");
  const [reportType, setReportType] = useState("District Wise");
  const [area, setArea] = useState("All");
  const [category, setCategory] = useState("All");
  const [sanction, setSanction] = useState("All");
  const updatedDate = new Date().toISOString().split("T")[0];
  const [period, setPeriod] = useState(updatedDate);
  const formik = useFormik({
    initialValues: {
      report_type: "District",
      period: updatedDate,
      area: "All",
      category: "All",
      district: "0",
      division: "0",
      constituency: "0",
      mandal: "0",
      secretariat: "0",
      contractor: "0",
      layout: "0",
      sanctioned: "All",
    },
    onSubmit: (values) => {
      let params = {
        report_type: values.report_type,
        period: moment(values.period).format("DD-MM-YYYY"),
        area: values.area,
        dist_code: values.district,
        div_code: values.division,
        cont_code: values.constituency,
        mandal_code: values.mandal,
        sec_code: values.secretariat,
        contract_id: values.contractor,
        layout_code: values.layout,
        categorys: values.category,
        sanctioned: values.sanctioned,
      };
      if (values.report_type === "District") {
        setReportType("District Wise");
      } else if (values.report_type === "Division") {
        setReportType("Division Wise");
      } else if (values.report_type === "Constituency") {
        setReportType("Constituency Wise");
      } else if (values.report_type === "Mandal") {
        setReportType("Mandal Wise");
      } else if (values.report_type === "Secretariat") {
        setReportType("Secretariat Wise");
      } else if (values.report_type === "Contractorwise") {
        setReportType("Contractor Wise");
      } else if (values.report_type === "Layoutwise") {
        setReportType("Layout Wise");
      }
      setPeriod(values.period);
      setArea(values.area);
      setCategory(values.category);
      setSanction(values.sanctioned);
      store.dispatch({ type: "SHOW_SPINNER" });
      HousingService.getNPIArchPaymentReport(params).then((res) => {
        if (res.data) {
          setData(res.data);
          store.dispatch({ type: "HIDE_SPINNER" });
          if (values.report_type === "District") {
            if (values.district !== "0") {
              setdistname(res.data[0].dist_name);
            } else {
              setdistname("All");
            }
          }
          if (values.report_type === "Division") {
            if (values.district !== "0") {
              setdistname(res.data[0].dist_name);
              if (values.division !== "0") {
                setDivname(res.data[0].div_name);
              } else {
                setDivname("All");
              }
            } else {
              setdistname("All");
              setDivname("All");
            }
          }
          if (values.report_type === "Constituency") {
            if (
              values.district !== "0" &&
              values.division === "0" &&
              values.constituency === "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname("All");
              setConstname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency === "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency !== "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname(res.data[0].div_name);
            } else {
              setdistname("All");
              setDivname("All");
              setConstname("All");
            }
          }
          if (values.report_type === "Contractorwise") {
            if (values.district !== "0" && values.division === "0") {
              setdistname(res.data[0].dist_name);
              setDivname("All");
              setConstname("All");
              setContractname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency === "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname("All");
              setContractname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency !== "0" &&
              values.contractor === "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname(res.data[0].cont_name);
              setContractname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency !== "0" &&
              values.contractor !== "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname(res.data[0].cont_name);
              setContractname(res.data[0].contract_name);
            } else {
              if (values.district === "0" && values.contractor !== "0") {
                setdistname(res.data[0].dist_name);
                setContractname(res.data[0].contract_name);
              }
              setdistname("All");
              setDivname("All");
              setConstname("All");
              setContractname("All");
            }
          }
          if (values.report_type === "Mandal") {
            if (values.district !== "0" && values.division === "0") {
              setdistname(res.data[0].dist_name);
              setDivname("All");
              setConstname("All");
              setMandalname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency === "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname("All");
              setMandalname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency !== "0" &&
              values.mandal === "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname(res.data[0].cont_name);
              setMandalname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency !== "0" &&
              values.mandal !== "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname(res.data[0].cont_name);
              setMandalname(res.data[0].mandal_name);
            } else {
              setdistname("All");
              setDivname("All");
              setConstname("All");
              setMandalname("All");
            }
          }
          if (values.report_type === "Secretariat") {
            if (values.district !== "0" && values.division === "0") {
              setdistname(res.data[0].dist_name);
              setDivname("All");
              setConstname("All");
              setMandalname("All");
              setSecname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency === "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname("All");
              setMandalname("All");
              setSecname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency !== "0" &&
              values.mandal === "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname(res.data[0].cont_name);
              setMandalname("All");
              setSecname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency !== "0" &&
              values.mandal !== "0" &&
              values.secretariat === "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname(res.data[0].cont_name);
              setMandalname(res.data[0].mandal_name);
              setSecname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency !== "0" &&
              values.mandal !== "0" &&
              values.secretariat !== "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname(res.data[0].cont_name);
              setMandalname(res.data[0].mandal_name);
              setSecname(res.data[0].sec_name);
            } else {
              setdistname("All");
              setDivname("All");
              setConstname("All");
              setMandalname("All");
              setSecname("All");
            }
          }
          if (values.report_type === "Layoutwise") {
            if (values.district !== "0" && values.division === "0") {
              setdistname(res.data[0].dist_name);
              setDivname("All");
              setConstname("All");
              setMandalname("All");
              setLayoutname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency === "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname("All");
              setMandalname("All");
              setLayoutname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency !== "0" &&
              values.mandal === "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname(res.data[0].cont_name);
              setMandalname("All");
              setLayoutname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency !== "0" &&
              values.mandal !== "0" &&
              values.layout === "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname(res.data[0].cont_name);
              setMandalname(res.data[0].mandal_name);
              setLayoutname("All");
            } else if (
              values.district !== "0" &&
              values.division !== "0" &&
              values.constituency !== "0" &&
              values.mandal !== "0" &&
              values.layout !== "0"
            ) {
              setdistname(res.data[0].dist_name);
              setDivname(res.data[0].div_name);
              setConstname(res.data[0].cont_name);
              setMandalname(res.data[0].mandal_name);
              setSecname(res.data[0].layout_name);
            } else {
              setdistname("All");
              setDivname("All");
              setConstname("All");
              setMandalname("All");
              setLayoutname("All");
            }
          }
          setBenTable(false);
          setPaymentTable(true);
          $(function () {
            function tally(selector) {
              $(selector).each(function () {
                var total = 0,
                  column = $(this).siblings(selector).addBack().index(this);
                $("#my-table tbody tr").each(function () {
                  total +=
                    parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
                });
                $(this).html(total);
              });
            }

            tally("td.total");
          });
        }
      });

      if (formik.values.report_type === "District") {
        setTableDistEn(true);
        setTableDivEn(false);
        setTableConstEn(false);
        setTableMandEn(false);
        setTableSecEn(false);
        setTableContrEn(false);
        setTablelayoutEn(false);
      }
      if (formik.values.report_type === "Division") {
        setTableDistEn(false);
        setTableDivEn(true);
        setTableConstEn(false);
        setTableMandEn(false);
        setTableSecEn(false);
        setTableContrEn(false);
        setTablelayoutEn(false);
      }
      if (formik.values.report_type === "Constituency") {
        setTableDistEn(false);
        setTableDivEn(false);
        setTableConstEn(true);
        setTableMandEn(false);
        setTableSecEn(false);
        setTableContrEn(false);
        setTablelayoutEn(false);
      }
      if (formik.values.report_type === "Mandal") {
        setTableDistEn(false);
        setTableDivEn(false);
        setTableConstEn(false);
        setTableMandEn(true);
        setTableSecEn(false);
        setTableContrEn(false);
        setTablelayoutEn(false);
      }
      if (formik.values.report_type === "Secretariat") {
        setTableDistEn(false);
        setTableDivEn(false);
        setTableConstEn(false);
        setTableMandEn(false);
        setTableSecEn(true);
        setTableContrEn(false);
        setTablelayoutEn(false);
      }
      if (formik.values.report_type === "Contractorwise") {
        setTableDistEn(false);
        setTableDivEn(false);
        setTableConstEn(false);
        setTableMandEn(false);
        setTableSecEn(false);
        setTableContrEn(true);
        setTablelayoutEn(false);
      }
      if (formik.values.report_type === "Layoutwise") {
        setTableDistEn(false);
        setTableDivEn(false);
        setTableConstEn(false);
        setTableMandEn(false);
        setTableSecEn(false);
        setTableContrEn(false);
        setTablelayoutEn(true);
      }
    },
  });

  React.useEffect(() => {
    setDivEn(false);
    setconstEn(false);
    setmandalEn(false);
    setSecEn(false);
    setcontEnb(false);
    setlayEnb(false);
    setTableDistEn(true);
    setTableDivEn(false);
    setTableConstEn(false);
    setTableMandEn(false);
    setTableSecEn(false);
    setTableContrEn(false);
    setTablelayoutEn(false);
    setPaymentTable(true);
    setBenTable(false);
    setdistname("All");
    setReportType("District Wise");
    setPeriod(updatedDate);
    setArea("All");
    setCategory("All");
    setSanction("All");
    formik.setFieldValue("report_type", "District");
    formik.setFieldValue("period", updatedDate);
    formik.setFieldValue("area", "All");
    formik.setFieldValue("district", "0");
    formik.setFieldValue("category", "All");
    formik.setFieldValue("sanctioned", "All");
    let params = {
      report_type: formik.values.report_type,
      dist_code: 0,
      div_code: 0,
      cont_code: 0,
      mandal_code: 0,
      contract_id: 0,
      sanctioned: "All",
      area: "All",
      categorys: "All",
      period: moment(formik.values.period).format("DD-MM-YYYY"),
    };
    store.dispatch({ type: "SHOW_SPINNER" });

    HousingService.DistDivConstMandlBasedVillages(0, 0, 0, 0).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.dist_code}>
              {item.dist_name}
            </option>
          );
        });
        setDistList(options);
      }
    });

    getContractorsDropdown();
    HousingService.getNPIArchPaymentReport(params).then((res) => {
      if (res.data) {
        setData(res.data);
        $(function () {
          function tally(selector) {
            $(selector).each(function () {
              var total = 0,
                column = $(this).siblings(selector).addBack().index(this);
              $("#my-table tbody tr").each(function () {
                total +=
                  parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
              });
              $(this).html(total);
            });
          }
          tally("td.total");
        });
      }
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  }, []);

  const handleChangeReport = (e) => {
    if (e.target.value === "District") {
      setDivEn(false);
      setconstEn(false);
      setmandalEn(false);
      setSecEn(false);
      setcontEnb(false);
      setlayEnb(false);
    }
    if (e.target.value === "Division") {
      setDivEn(true);
      setconstEn(false);
      setmandalEn(false);
      setcontEnb(false);
      setlayEnb(false);
    }
    if (e.target.value === "Constituency") {
      setDivEn(true);
      setconstEn(true);
      setmandalEn(false);
      setSecEn(false);
      setcontEnb(false);
      setlayEnb(false);
    }
    if (e.target.value === "Mandal") {
      setDivEn(true);
      setconstEn(true);
      setmandalEn(true);
      setSecEn(false);
      setcontEnb(false);
      setlayEnb(false);
    }
    if (e.target.value === "Secretariat") {
      setDivEn(true);
      setconstEn(true);
      setmandalEn(true);
      setSecEn(true);
      setcontEnb(false);
      setlayEnb(false);
    }

    if (e.target.value === "Contractorwise") {
      setDivEn(true);
      setconstEn(true);
      setmandalEn(false);
      setSecEn(false);
      setcontEnb(true);
      setlayEnb(false);
    }
    if (e.target.value === "Layoutwise") {
      setDivEn(true);
      setconstEn(true);
      setmandalEn(true);
      setcontEnb(false);
      setSecEn(false);
      setlayEnb(true);
    }
  };
  const getDivList = (e) => {
    let dist_code = e.target.value;
    if (dist_code !== "0") {
      HousingService.DistDivConstMandlBasedVillages(dist_code, 0, 0, 0).then(
        (res) => {
          if (res.data) {
            let options = res.data.map((item, i) => {
              return (
                <option key={i} value={item.div_code}>
                  {item.div_name}
                </option>
              );
            });
            setDivisionList(options);
          }
          formik.setFieldValue("division", "0");
        }
      );
    } else {
      setDivisionList([]);
    }
  };
  const getContList = (e) => {
    let div_code = e.target.value;
    if (div_code !== "0") {
      HousingService.DistDivConstMandlBasedVillages(
        formik.values.district,
        div_code,
        0,
        0
      ).then((res) => {
        if (res.data) {
          let options = res.data.map((item, i) => {
            return (
              <option key={i} value={item.cont_code}>
                {item.cont_name}
              </option>
            );
          });

          setConstituencyList(options);
        }

        formik.setFieldValue("constituency", "0");
      });
    } else {
      setConstituencyList([]);
    }
  };
  const getMandalList = (e) => {
    let cont_code = e.target.value;
    if (cont_code !== "0") {
      HousingService.DistDivConstMandlBasedVillages(
        formik.values.district,
        formik.values.division,
        cont_code,
        0
      ).then((res) => {
        if (res.data) {
          let options = res.data.map((item, i) => {
            return (
              <option key={i} value={item.mandal_code}>
                {item.mandal_name}
              </option>
            );
          });
          setMandalList(options);
          formik.setFieldValue("secretariat", "0");
          formik.setFieldValue("mandal", "0");
        }
      });
    } else {
      setMandalList([]);
      setSecretariatList([]);
      setLayoutList([]);
    }
  };
  const getContractorList = (e) => {
    let cont_code = e.target.value;
    if (cont_code !== "0") {
      HousingService.ConstituencyBasedContractors(
        formik.values.district,
        cont_code
      ).then((res) => {
        if (res.data) {
          let options = res.data.map((item, i) => {
            return (
              <option key={i} value={item.contract_id}>
                {item.contract_name}
              </option>
            );
          });
          setContractorList(options);
          formik.setFieldValue("contractor", "0");
        }
      });
    }
  };
  const getContractorsDropdown = () => {
    HousingService.getContractorsDropdown().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.contract_id}>
              {item.contract_name}
            </option>
          );
        });
        setContractorList(options);
      }
    });
  };
  const getSecretariatList = (e) => {
    let mandal_code = e.target.value;
    if (mandal_code !== "0") {
      HousingService.MandalsBasedSecrateriats(
        formik.values.district,
        mandal_code
      ).then((res) => {
        if (res.data) {
          let options = res.data.map((item, i) => {
            return (
              <option key={i} value={item.secretariat_code}>
                {item.secretariat_name}
              </option>
            );
          });
          formik.setFieldValue("secretariat", "0");
          setSecretariatList(options);
        }
      });
    } else {
      setSecretariatList([]);
    }
  };
  const getLayoutList = (e) => {
    let mandal_code = e.target.value;
    if (mandal_code !== "0") {
      HousingService.DistMandalBasedLayoutDropdown(
        formik.values.district,
        mandal_code
      ).then((res) => {
        if (res.data) {
          let options = res.data.map((item, i) => {
            return (
              <option key={i} value={item.infra_id}>
                {item.layout_name}
              </option>
            );
          });

          setLayoutList(options);
          formik.setFieldValue("layout", "0");
        }
      });
    } else {
      setLayoutList([]);
    }
  };
  const divisionListing = (dist_code) => {
    let params = {
      report_type: "Division",
      dist_code: dist_code,
      div_code: 0,
      cont_code: 0,
      mandal_code: 0,
      sanctioned: formik.values.sanctioned,
      area: formik.values.area,
      categorys: formik.values.category,
      period: formik.values.period,
    };
    setReportType("Division Wise");
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.getNPIArchPaymentReport(params).then((res) => {
      if (res.data) {
        setData(res.data);
        setTableDivEn(true);
        setTableDistEn(false);
        $(function () {
          function tally(selector) {
            $(selector).each(function () {
              var total = 0,
                column = $(this).siblings(selector).addBack().index(this);
              $("#my-table tbody tr").each(function () {
                total +=
                  parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
              });
              $(this).html(total);
            });
          }

          tally("td.total");
        });
      }
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  };
  const constituencyListing = (dist_code, div_code) => {
    let params = {
      report_type: "Constituency",
      dist_code: dist_code,
      div_code: div_code,
      cont_code: 0,
      mandal_code: 0,
      sanctioned: formik.values.sanctioned,
      area: formik.values.area,
      categorys: formik.values.category,
      period: formik.values.period,
    };
    setReportType("Constituency Wise");
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.getNPIArchPaymentReport(params).then((res) => {
      if (res.data) {
        setData(res.data);
        setTableDivEn(false);
        setTableDistEn(false);
        setTableConstEn(true);
        $(function () {
          function tally(selector) {
            $(selector).each(function () {
              var total = 0,
                column = $(this).siblings(selector).addBack().index(this);
              $("#my-table tbody tr").each(function () {
                total +=
                  parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
              });
              $(this).html(total);
            });
          }
          tally("td.total");
        });
      }
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  };
  const mandalListing = (dist_code, div_code, cont_code) => {
    let params = {
      report_type: "Mandal",
      dist_code: dist_code,
      div_code: div_code,
      cont_code: cont_code,
      mandal_code: 0,
      sanctioned: formik.values.sanctioned,
      area: formik.values.area,
      categorys: formik.values.category,
      period: formik.values.period,
    };
    setReportType("Mandal Wise");
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.getNPIArchPaymentReport(params).then((res) => {
      if (res.data) {
        setData(res.data);
        setTableDivEn(false);
        setTableDistEn(false);
        setTableConstEn(false);
        setTableMandEn(true);
        $(function () {
          function tally(selector) {
            $(selector).each(function () {
              var total = 0,
                column = $(this).siblings(selector).addBack().index(this);
              $("#my-table tbody tr").each(function () {
                total +=
                  parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
              });
              $(this).html(total);
            });
          }
          tally("td.total");
        });
      }
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  };
  const secretariatListing = (dist_code, div_code, cont_code, mandal_code) => {
    let params = {
      report_type: "Secretariat",
      dist_code: dist_code,
      div_code: div_code,
      cont_code: cont_code,
      mandal_code: mandal_code,
      sanctioned: formik.values.sanctioned,
      area: formik.values.area,
      categorys: formik.values.category,
      period: formik.values.period,
    };
    setReportType("Secretariat Wise");
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.getNPIArchPaymentReport(params).then((res) => {
      if (res.data) {
        setData(res.data);
        setTableDivEn(false);
        setTableDistEn(false);
        setTableConstEn(false);
        setTableMandEn(false);
        setTableSecEn(true);
        $(function () {
          function tally(selector) {
            $(selector).each(function () {
              var total = 0,
                column = $(this).siblings(selector).addBack().index(this);
              $("#my-table tbody tr").each(function () {
                total +=
                  parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
              });
              $(this).html(total);
            });
          }
          tally("td.total");
        });
      }
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  };
  const getNPIArchPaymentReportBenDetails = (
    dist_code,
    div_code,
    cont_code,
    mandal_code,
    sec_code,
    contract_id,
    layout_code,
    sanctioned,
    area,
    categorys,
    period
  ) => {
    let params = {
      dist_code: dist_code === null ? 0 : dist_code,
      cont_code: cont_code === null ? 0 : cont_code,
      div_code: div_code === null ? 0 : div_code,
      mandal_code: mandal_code === null ? 0 : mandal_code,
      sec_code: sec_code === "null" ? 0 : sec_code,
      layout_code: layout_code === "null" ? 0 : layout_code,
      contract_id: contract_id === "null" ? 0 : contract_id,
      sanctioned: sanctioned,
      area: area,
      categorys: categorys,
      period: period,
    };
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.getNPIArchPaymentReportBenDetails(params).then((res) => {
      if (res.data) {
        setDetails(res.data);
        setPaymentTable(false);
        setBenTable(true);
        $(function () {
          function tally(selector) {
            $(selector).each(function () {
              var total = 0,
                column = $(this).siblings(selector).addBack().index(this);
              $("#my-table tbody tr").each(function () {
                total +=
                  parseFloat($(".sum:eq(" + column + ")", this).html()) || 0;
              });
              $(this).html(total);
            });
          }
          tally("td.total");
        });
      }
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  };

  function generate() {
    const pageWidth = 210; 
    const pageHeight = 297; 
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: [pageWidth, pageHeight] });

    const imgPath = "/img/APSHCL_logo.png";
    const headingText2 = "Andhra Pradesh State Housing Corporation Limited (APSHCL)";
    const headingText3 = `${area} :Area, ${category} :Category, ${sanction} Construction Type`;
    const headingText4 = ` Physical Progress Archieve Report as on date :${updatedDate}, ${distname} :District`;

    const fontSize = 10;
    const textWidth2 = (doc.getStringUnitWidth(headingText2) * fontSize) / doc.internal.scaleFactor;
    const textWidth3 = (doc.getStringUnitWidth(headingText3) * fontSize) / doc.internal.scaleFactor;
    const textWidth4 = (doc.getStringUnitWidth(headingText4) * fontSize) / doc.internal.scaleFactor;

    const tableYStart = 35;
    doc.setFontSize(fontSize);

    doc.setTextColor(0, 0, 0);  

    const xCoordinate2 = (pageWidth - textWidth2) / 2;
    const xCoordinate3 = (pageWidth - textWidth3) / 2;
    const xCoordinate4 = (pageWidth - textWidth4) / 2;

    doc.text(headingText2, xCoordinate2, 10);
    doc.text(headingText4, xCoordinate4, 20);
    doc.text(headingText3, xCoordinate3, 30);

    doc.addImage(imgPath, "PNG", 7, 7, 25, 25);

    doc.autoTable({
      html: "#my-table",
      theme: "grid",
      tableWidth: "auto",
      columnStyles: {
        3: { cellWidth: "wrap" },
      },
      startY: tableYStart,
      margin: { top: 5, right: 15, bottom: 5, left: 15 },
      styles: {
        fontSize: 6,
      },
      columnWidth: { 0: 20, 1: 30, 2: 40 },
    });

    doc.save("PhysicalProgressReport.pdf");
  }
  return (
    <>
      <NavigationServicesHeader />
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>
        <ModuleHeader title="Physical Progress Archieve Report" />
          <OFMSUI.Container className="outer-page-content-container " fluid style={{ width: "90%" }} >
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" >
                <FormGroup as={Col}>
                  <label>
                    <b> Report Type</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    *
                  </span>
                  <Field
                    component="select"
                    name="report_type"
                    className={
                      formik.touched.report_type && formik.errors.report_type
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onChange={(e) => {
                      handleChangeReport(e);
                        getContractorsDropdown();
                        formik.handleChange(e);
                        formik.setFieldValue("sanctioned", "All");
                        formik.setFieldValue("area", "All");
                        formik.setFieldValue("period", updatedDate);
                        formik.setFieldValue("category", "All");
                        formik.setFieldValue("district", "0");
                        formik.setFieldValue("division", "0");
                        formik.setFieldValue("constituency", "0");
                        formik.setFieldValue("mandal", "0");
                        formik.setFieldValue("secretariat", "0");
                        formik.setFieldValue("contractor", "0");
                        formik.setFieldValue("layout", "0");
                        setDivisionList([]);
                        setConstituencyList([]);
                        setMandalList([]);
                        setSecretariatList([]);
                        setLayoutList([]);
                    }}
                  >
                    <option value="District">District Wise</option>
                    <option value="Division">Division Wise</option>
                    <option value="Constituency">Constituency Wise</option>
                    <option value="Mandal">Mandal Wise</option>
                    <option value="Secretariat">secretariat Wise</option>
                    <option value="Contractorwise">Contractor Wise</option>
                    <option value="Layoutwise">Layout Wise</option>
                  </Field>
                </FormGroup>
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" >
                <FormGroup as={Col}>
                  <label>
                    <b>Date</b>
                  </label>
                  <Field
                    type="date"
                    name="period"
                    defaultValue={updatedDate}
                    className={
                      formik.touched.period && formik.errors.period
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onChange={(e) => {
                      formik.handleChange(e);
                        formik.setFieldValue("area", "All");
                        formik.setFieldValue("sanctioned", "All");
                        formik.setFieldValue("category", "All");
                        formik.setFieldValue("district", "0");
                        formik.setFieldValue("division", "0");
                        formik.setFieldValue("constituency", "0");
                        formik.setFieldValue("mandal", "0");
                        formik.setFieldValue("secretariat", "0");
                        formik.setFieldValue("contractor", "0");
                        formik.setFieldValue("layout", "0");
                        setDivisionList([]);
                        setConstituencyList([]);
                        setMandalList([]);
                        setSecretariatList([]);
                        setLayoutList([]);
                    }}
                  >
                  </Field>
                </FormGroup>
              </OFMSUI.Col>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={1}
                xl={1}
                xxl={1}
                className="mb-3"
              >
                <FormGroup as={Col}>
                  <label>
                    <b>Area</b>
                  </label>
                 
                  <Field
                    component="select"
                    name="area"
                    className={
                      formik.touched.area && formik.errors.area
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onChange={(e) => {
                      formik.handleChange(e);
                        formik.setFieldValue("sanctioned", "All");
                        formik.setFieldValue("category", "All");
                        formik.setFieldValue("district", "0");
                        formik.setFieldValue("division", "0");
                        formik.setFieldValue("constituency", "0");
                        formik.setFieldValue("mandal", "0");
                        formik.setFieldValue("secretariat", "0");
                        formik.setFieldValue("contractor", "0");
                        formik.setFieldValue("layout", "0");
                        setDivisionList([]);
                        setConstituencyList([]);
                        setMandalList([]);
                        setSecretariatList([]);
                        setLayoutList([]);
                    }}
                  >
                    <option value="All">All</option>
                    <option value="UDA">UDA</option>
                    <option value="ULB">ULB</option>
                  </Field>
                </FormGroup>
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" >
                <FormGroup as={Col}>
                  <label>
                    <b>Category</b>
                  </label>
                 
                  <Field
                    component="select"
                    name="category"
                    className={
                      formik.touched.category && formik.errors.category
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onChange={(e) => {
                      formik.handleChange(e);
                        formik.setFieldValue("sanctioned", "All");
                        formik.setFieldValue("district", "0");
                        formik.setFieldValue("division", "0");
                        formik.setFieldValue("constituency", "0");
                        formik.setFieldValue("mandal", "0");
                        formik.setFieldValue("secretariat", "0");
                        formik.setFieldValue("contractor", "0");
                        formik.setFieldValue("layout", "0");
                        setDivisionList([]);
                        setConstituencyList([]);
                        setMandalList([]);
                        setSecretariatList([]);
                        setLayoutList([]);
                    }}
                  >
                    <option value="All">All</option>
                    <option value="Pre NpI">Housing 2014-19 (taken up at 2019-24)</option>
                    <option value="NPI Phase I">PHASE I</option>
                    <option value="NPI Phase II">PHASE II</option>
                    <option value="NPI Phase III">PHASE III</option>
                  </Field>
                </FormGroup>
              </OFMSUI.Col>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={1}
                xl={1}
                xxl={1}
                className="mb-3"
              >
                <FormGroup as={Col}>
                  <label>
                    <b>ConstructionType</b>
                  </label>
                 
                  <Field
                    component="select"
                    name="sanctioned"
                    className={
                      formik.touched.sanctioned && formik.errors.sanctioned
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                  >
                    <option value="0">All</option>
                    <option value="Option1&2">Option 1&2</option>
                    <option value="Option3">Option 3</option>
                  </Field>
                </FormGroup>
              </OFMSUI.Col>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={2}
                xl={2}
                xxl={2}
                className=""
              >
                <FormGroup as={Col}>
                  <label>
                    <b> District</b>
                  </label>
                 
                  <Field
                    component="select"
                    name="district"
                    className={
                      formik.touched.district && formik.errors.district
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onChange={(e) => {
                      getDivList(e); formik.handleChange(e);
                      formik.setFieldValue("constituency", "0");
                      formik.setFieldValue("mandal", "0");
                      formik.setFieldValue("secretariat", "0");
                      formik.setFieldValue("contractor", "0");
                      formik.setFieldValue("layout", "0");
                      setConstituencyList([]);
                      setMandalList([]);
                      setSecretariatList([]);
                      setLayoutList([]);
                    }}
                  >
                    <option value="0">All</option>
                    {distList}
                  </Field>
                </FormGroup>
              </OFMSUI.Col>
              {divEn && (
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={2}
                  xl={2}
                  xxl={2}
                  className="mb-3"
                >
                  <label>
                    <b> Division</b>
                  </label>
                 
                  <Field
                    name="division"
                    component="select"
                    className={
                      formik.touched.division && formik.errors.division
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onChange={(e) => {
                      getContList(e); formik.handleChange(e);
                      formik.setFieldValue("mandal", "0");
                      formik.setFieldValue("secretariat", "0");
                      formik.setFieldValue("contractor", "0");
                      formik.setFieldValue("layout", "0");
                      setMandalList([]);
                      setSecretariatList([]);
                      setLayoutList([]);
                    }}
                  >
                    <option value="0">All</option>
                    {divisionList}
                  </Field>
                </OFMSUI.Col>
              )}
              {constEn && (
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={2}
                  xl={2}
                  xxl={2}
                  className="mb-3"
                >
                  <label>
                    <b> Constituency</b>
                  </label>
                  
                  <Field
                    component="select"
                    name="constituency"
                    className={
                      formik.touched.constituency && formik.errors.constituency
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onChange={(e) => {
                      getMandalList(e);
                        getContractorList(e);
                        formik.handleChange(e);
                      formik.setFieldValue("secretariat", "0");
                      formik.setFieldValue("contractor", "0");
                      formik.setFieldValue("layout", "0");
                      setLayoutList([]);
                    }}
                  >
                    <option value="0">All</option>
                    {constituencyList}
                  </Field>
                </OFMSUI.Col>
              )}
              {mandalEn && (
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={2}
                  xl={2}
                  xxl={2}
                  className="mb-3"
                >
                  <label>
                    <b> Mandal</b>
                  </label>
                 
                  <Field
                    component="select"
                    name="mandal"
                    className={
                      formik.touched.mandal && formik.errors.mandal
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onChange={(e) => {
                      getSecretariatList(e);
                        getLayoutList(e);
                        formik.handleChange(e);
                    }}
                  >
                    {" "}
                    <option value="0">All</option>
                    {mandalList}
                  </Field>
                </OFMSUI.Col>
              )}
              {secEn && (
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={2}
                  xl={2}
                  xxl={2}
                  className="mb-3"
                >
                  <label>
                    <b> Secretariat</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    *
                  </span>
                  <Field
                    component="select"
                    name="secretariat"
                    className={
                      formik.touched.secretariat && formik.errors.secretariat
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    onChange={(e) => formik.handleChange(e)}
                  >
                    {" "}
                    <option value="0">All</option>
                    {secretariatList}
                  </Field>
                </OFMSUI.Col>
              )}
              {contEnb && (
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={2}
                  xl={2}
                  xxl={2}
                  className="mb-3"
                >
                  <label>
                    <b> Contractor</b>
                  </label>
                
                  <Field
                    component="select"
                    name="contractor"
                    className={
                      formik.touched.contractor && formik.errors.contractor
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                  >
                    {" "}
                    <option value="0">All</option>
                    {contractorList}
                  </Field>
                </OFMSUI.Col>
              )}
              {layenb && (
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={2}
                  xl={2}
                  xxl={2}
                  className="mb-3"
                >
                  <label>
                    <b> Layout</b>
                  </label>
                 
                  <Field
                    component="select"
                    name="layout"
                    className={
                      formik.touched.layout && formik.errors.layout
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                  >
                    <option value="0">All</option>
                    {layoutList}
                  </Field>
                </OFMSUI.Col>
              )}
              <GetDetails />

            </OFMSUI.Row>
            <OFMSUI.Row>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={3}
                lg={3}
                xl={3}
                xxl={3}
                className=" mb-3"
              >
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div
                      class="input-group-text group_txt11"
                      id="btnGroupAddon"
                    >
                      <AiOutlineSearch />
                    </div>
                  </div>
                  <input
                    type="text"
                    id=""
                    placeholder="Search"
                    style={{ width: "25%" }}
                    className="form-control input-lg"
                    onChange={(event) => setSearch(event.target.value)}
                  ></input>
                </div>
              </OFMSUI.Col>

              <OFMSUI.Col
                xs={12}
                sm={12}
                md={9}
                lg={9}
                xl={9}
                xxl={9}
                className=" mb-2 float-end"
              >
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={generate}
                  style={{ float: "right", marginLeft: "3px" }}
                >
                  PDF
                  <MdOutlinePictureAsPdf />
                </button>
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  style={{ float: "right", color: "#fff" }}
                >
                  <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="download-table-xls-button"
                    table="my-table"
                    filename="PhysicalProgressReport"
                    sheet="tablexls"
                    buttonText="Excel"
                  >
                    <FaFileExcel style={{ color: "#fff" }} />
                  </ReactHTMLTableToExcel>
                </button>
              </OFMSUI.Col>
            </OFMSUI.Row>
            <OFMSUI.Row>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={10}
                lg={10}
                xl={10}
                xxl={10}
                className=" mb-3"
              >
                {/* <div>
                  <span
                    className="headernames "
                    style={{ marginRight: "0.5rem" }}
                  >
                    Report Type :
                  </span>
                  <b className="" style={{ marginRight: "0.8rem" }}>
                    {reportType}
                  </b>
                  <span
                    className="headernames "
                    style={{ marginRight: "0.5rem" }}
                  >
                    Date :
                  </span>
                  <b className="" style={{ marginRight: "0.8rem" }}>
                    {period}
                  </b>
                  <span
                    className="headernames "
                    style={{ marginRight: "0.5rem" }}
                  >
                    Area :
                  </span>
                  <b className="" style={{ marginRight: "0.8rem" }}>
                    {area}
                  </b>
                  <span
                    className="headernames "
                    style={{ marginRight: "0.5rem" }}
                  >
                    Category :
                  </span>
                  <b className="" style={{ marginRight: "0.8rem" }}>
                    {category}
                  </b>
                  <span
                    className="headernames "
                    style={{ marginRight: "0.5rem" }}
                  >
                    Construction Type :
                  </span>
                  <b className="" style={{ marginRight: "0.8rem" }}>
                    {sanction}
                  </b>
                  <span
                    className="headernames "
                    style={{ marginRight: "0.5rem" }}
                  >
                    District :
                  </span>
                  <b className="" style={{ marginRight: "0.8rem" }}>
                    {distname}
                  </b>
                  {tableDivEn && (
                    <>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Division :
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {divname}
                      </b>
                    </>
                  )}
                  {tableConstEn && (
                    <>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Division :
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {divname}
                      </b>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Constituency:
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {constname}
                      </b>
                    </>
                  )}
                  {tableMandEn && (
                    <>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Division :
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {divname}
                      </b>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Constituency:
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {constname}
                      </b>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Mandal :
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {mandalname}
                      </b>
                    </>
                  )}
                  {tableSecEn && (
                    <>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Division :
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {divname}
                      </b>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Constituency:
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {constname}
                      </b>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Mandal :
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {mandalname}
                      </b>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Secretariat :
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {secname}
                      </b>
                    </>
                  )}
                  {tableContrEn && (
                    <>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Contractor :
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {contractname}
                      </b>
                    </>
                  )}
                  {tableLayoutEn && (
                    <>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Mandal :
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {mandalname}
                      </b>
                      <span
                        className="headernames "
                        style={{ marginRight: "0.5rem" }}
                      >
                        Layout :
                      </span>
                      <b className="" style={{ marginRight: "0.8rem" }}>
                        {layoutname}
                      </b>
                    </>
                  )}
                </div> */}
              </OFMSUI.Col>
              {benTable && (
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={2}
                  lg={2}
                  xl={2}
                  xxl={2}
                  className=" mb-3 float-end"
                >
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm"
                    style={{ float: "right", marginLeft: "3px", backgroundColor: "#603913",borderColor: "#603913", color: "#fff"}}
                  >
                   <FaFastBackward /> &nbsp;Back
                  </button>
                </OFMSUI.Col>
              )}
            </OFMSUI.Row>

            {paymentTable && (
              <div style={{ overflow: "auto", margin: "0px", height: "620px" }}>
                <OFMSUI.Table striped bordered hover id="my-table" indexid="index" style={{ marginTop: "15px" }} >
                  <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} >
                    <tr> <th colSpan={21} style={{ textAlign: "center" }}> <h6> Physical Progress Archieve Report as on date {updatedDate},{distname} District,{area} :Area, {category} :Category, {sanction} Construction Type</h6> </th> </tr>
                    <tr className="table_countshead">
                      <th style={{ width: "100px" }}>S No.</th>
                      {tableDistEn && ( <th style={{ width: "200px" }}>District</th> )}
                      {tableDivEn && ( <> <th style={{ width: "200px" }}>District</th> <th style={{ width: "200px" }}>Division</th> </> )}
                      {tableConstEn && ( <> <th style={{ width: "200px" }}>District</th> <th style={{ width: "200px" }}>Division</th> <th>Constituency</th> </> )}
                      {tableMandEn && ( <> <th style={{ width: "200px" }}>District</th> <th style={{ width: "200px" }}>Division</th> <th>Constituency</th> <th>Mandal</th> </> )}
                      {tableSecEn && ( <> <th style={{ width: "200px" }}>District</th> <th style={{ width: "200px" }}>Division</th> <th>Constituency</th> <th style={{ width: "200px" }}>Mandal</th> <th style={{ width: "220px" }}>Secretariat</th> </> )}
                      {tableContrEn && ( <> <th style={{ width: "200px" }}>District</th> <th style={{ width: "170px" }}>Contractor Id</th> <th style={{ width: "200px" }}>Contractor</th> </> )}
                      {tableLayoutEn && ( <> <th style={{ width: "200px" }}>District</th> <th style={{ width: "200px" }}>Mandal</th> <th style={{ width: "200px" }}>Layout Id</th> <th style={{ width: "200px" }}>Layout</th> </> )}
                      <th style={{ width: "150px" }}>No. of. Beneficiaries</th>
                      <th style={{ width: "100px" }}>NS</th>
                      <th style={{ width: "100px" }}>BBL</th>
                      <th style={{ width: "100px" }}>PC</th>
                      <th style={{ width: "100px" }}>PB</th>
                      <th style={{ width: "100px" }}>BL</th>
                      <th style={{ width: "100px" }}>LL</th>
                      <th style={{ width: "100px" }}>RL</th>
                      <th style={{ width: "100px" }}>RC</th>
                      <th style={{ width: "150px" }}>Completion</th>
                      <th style={{ width: "150px" }}>Cash Payment</th>
                      <th style={{ width: "150px" }}>Material</th>
                      <th style={{ width: "180px" }}> State Component <br /> as per G.O. No. 01 <br /> on 23-03-2022 </th>
                      <th style={{ width: "150px" }}>Total Payment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.length === 0 ? (
                      <tr>
                        <td
                          style={{ textAlign: "center", color: "red" }}
                          colSpan={20}
                        >
                          No Details Found.
                        </td>
                      </tr>
                    ) : (
                      data
                        ?.filter((element) =>
                          (
                            element.dist_name +
                            element.div_name +
                            element.cont_name +
                            element.mandal_name +
                            element.sec_name
                          )
                            .toLowerCase()
                            .includes(search.toLowerCase())
                        )
                        .map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            {tableDistEn && (
                              <td
                                onClick={() => {
                                  setdistname(item.dist_name);
                                    setDivname("All");
                                    divisionListing(item.dist_code);
                                }}
                              >
                                <Link style={{ cursor: "pointer" }}>
                                  {item.dist_name}
                                </Link>
                              </td>
                            )}
                            {tableDivEn && (
                              <>
                                <td>{item.dist_name}</td>
                                <td
                                  onClick={() => {
                                    setDivname(item.div_name);
                                      setConstname("All");
                                      constituencyListing(
                                        item.dist_code,
                                        item.div_code
                                      );
                                  }}
                                >
                                  <Link style={{ cursor: "pointer" }}>
                                    {item.div_name}
                                  </Link>
                                </td>
                              </>
                            )}
                            {tableConstEn && (
                              <>
                                <td>{item.dist_name}</td>
                                <td>{item.div_name}</td>
                                <td
                                  onClick={() => {
                                    setdistname(item.dist_name);
                                      setDivname(item.div_name);
                                      setConstname(item.cont_name);
                                      mandalListing(
                                        item.dist_code,
                                        item.div_code,
                                        item.cont_code
                                      );
                                  }}
                                >
                                  <Link style={{ cursor: "pointer" }}>
                                    {item.cont_name}
                                  </Link>
                                </td>
                              </>
                            )}
                            {tableMandEn && (
                              <>
                                <td>{item.dist_name}</td>
                                <td>{item.div_name}</td>
                                <td>{item.cont_name}</td>
                                <td
                                  onClick={() => {
                                    setdistname(item.dist_name);
                                      setMandalname(item.mandal_name);
                                      setDivname(item.div_name);
                                      setConstname(item.cont_name);
                                      setSecname("All");
                                      secretariatListing(
                                        item.dist_code,
                                        item.div_code,
                                        item.cont_code,
                                        item.mandal_code
                                      );
                                  }}
                                >
                                  <Link style={{ cursor: "pointer" }}>
                                    {item.mandal_name}
                                  </Link>
                                </td>
                              </>
                            )}
                            {tableSecEn && (
                              <>
                                <td>{item.dist_name}</td>
                                <td>{item.div_name}</td>
                                <td>{item.cont_name}</td>
                                <td>{item.mandal_name}</td>
                                <td>{item.sec_name}</td>
                              </>
                            )}
                            {tableContrEn && (
                              <>
                                <td>{item.dist_name}</td>
                                <td>{item.contract_id}</td>
                                <td>{item.contract_name}</td>
                              </>
                            )}
                            {tableLayoutEn && (
                              <>
                                <td>{item.dist_name}</td>
                                <td>{item.mandal_name}</td>
                                <td>{item.layout_no}</td>
                                <td>{item.layout_name}</td>
                              </>
                            )}
                            <td
                              style={{ textAlign: "right" }}
                              onClick={() => {
                                getNPIArchPaymentReportBenDetails(
                                  item.dist_code,
                                  item.div_code,
                                  item.cont_code,
                                  item.mandal_code,
                                  item.sec_code,
                                  item.contract_id,
                                  item.layout_no,
                                  formik.values.sanctioned,
                                  formik.values.area,
                                  formik.values.category,
                                  formik.values.period
                                );
                              }}
                            >
                              <Link style={{ cursor: "pointer" }} class="sum">
                                {item.no_of_bens}
                              </Link>
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.ns}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.bbl}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.pc}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.pb}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.bl}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.ll}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.rl}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.rc}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.comp}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.cash_payment}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {parseInt(item.material).toFixed(0)}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.state_component}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {parseInt(item.totalpayment).toFixed(0)}
                            </td>
                          </tr>
                        ))
                    )}
                  </tbody>
                  <tfoot
                    className="fw-bold"
                    style={{ position: "sticky", bottom: "0px" }}
                  >
                    <tr className="table_countshead">
                      <>
                        {tableDistEn && (
                          <td colSpan="2" style={{ textAlign: "center" }}>
                            Total
                          </td>
                        )}
                        {tableDivEn && (
                          <td colSpan="3" style={{ textAlign: "center" }}>
                            Total
                          </td>
                        )}
                        {tableConstEn && (
                          <td colSpan="4" style={{ textAlign: "center" }}>
                            Total
                          </td>
                        )}
                        {tableMandEn && (
                          <td colSpan="5" style={{ textAlign: "center" }}>
                            Total
                          </td>
                        )}
                        {tableSecEn && (
                          <td colSpan="6" style={{ textAlign: "center" }}>
                            Total
                          </td>
                        )}
                        {tableContrEn && (
                          <td colSpan="4" style={{ textAlign: "center" }}>
                            Total
                          </td>
                        )}
                        {tableLayoutEn && (
                          <td colSpan="5" style={{ textAlign: "center" }}>
                            Total
                          </td>
                        )}
                      </>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                      <td style={{ textAlign: "right" }} class="total"></td>
                    </tr>
                  </tfoot>
                </OFMSUI.Table>
              </div>
            )}
            {benTable && (
              <div style={{ overflow: "auto", margin: "0px", height: "620px" }}>
                <OFMSUI.Table
                  striped
                  bordered
                  hover
                  id="my-table"
                  indexid="index"
                  style={{ marginTop: "15px" }}
                >
                  <thead
                    className="fw-bold"
                    style={{ position: "sticky", top: "0px" }}
                  >
                    <tr>
                      <th colSpan={21} style={{ textAlign: "center" }}>
                        <h6>
                          Physical Progress Beneficiary Details Report
                        </h6>
                      </th>
                    </tr>
                    <tr className="table_countshead">
                      <th rowSpan={2}>S No.</th>
                      <th rowSpan={2}>District</th>
                      <th rowSpan={2}>Division</th>
                      <th rowSpan={2}>Constituency</th>
                      <th rowSpan={2}>Mandal</th>
                      <th rowSpan={2}>Secretariat</th>
                      <th rowSpan={2}>Contractor Id</th>
                      <th rowSpan={2}>Contractor</th>
                      <th rowSpan={2}>Layout Id</th>
                      <th rowSpan={2}>Layout</th>
                      <th rowSpan={2}>Beneficiary Id</th>
                      <th rowSpan={2}>PFMS Ben Code</th>
                      <th rowSpan={2}>Beneficiary Name</th>
                      <th rowSpan={2}>Completion Date</th>
                      <th rowSpan={2}>Phase Status</th>
                      <th colSpan={5} style={{ textAlign: "center" }}>
                        Payments
                      </th>
                      <th rowSpan={2}>Total Payment</th>
                    </tr>
                    <tr className="table_countshead">
                      <th>BBL</th>
                      <th>BL</th>
                      <th>RL</th>
                      <th>RC</th>
                      <th>Completion Payment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {details?.length === 0 ? (
                      <tr>
                        <td
                          style={{ textAlign: "center", color: "red" }}
                          colSpan={17}
                        >
                          No Details Found.
                        </td>
                      </tr>
                    ) : (
                      details
                        ?.filter((element) =>
                          (
                            element.dist_name +
                            element.div_name +
                            element.cont_name +
                            element.mandal_name +
                            element.sec_name +
                            element.ben_name +
                            element.ben_id
                          )
                            .toLowerCase()
                            .includes(search.toLowerCase())
                        )
                        .map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{item.dist_name}</td>
                            <td>{item.div_name}</td>
                            <td>{item.cont_name}</td>
                            <td>{item.mandal_name}</td>
                            <td>{item.sec_name}</td>
                            <td>{item.contract_id}</td>
                            <td>{item.contract_name}</td>
                            <td>{item.layout_code}</td>
                            <td>{item.layout_name}</td>
                            <td>{item.ben_id}</td>
                            <td>{item.pfms_ben_code}</td>
                            <td>{item.ben_name}</td>
                            <td>{item.comp_date}</td>
                            <td>{item.phase_status}</td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.bbl_m}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.bl_m}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.rl_m}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.rc_m}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.comp}
                            </td>
                            <td style={{ textAlign: "right" }} class="sum">
                              {item.total_payment}
                            </td>
                          </tr>
                        ))
                    )}
                  </tbody>
                  <tfoot
                    className="fw-bold"
                    style={{ position: "sticky", bottom: "0px" }}
                  >
                    <tr className="table_countshead">
                      <td colSpan={15} style={{ textAlign: "center" }}>
                        Total
                      </td>
                      <td class="total" style={{ textAlign: "right" }}></td>
                      <td class="total" style={{ textAlign: "right" }}></td>
                      <td class="total" style={{ textAlign: "right" }}></td>
                      <td class="total" style={{ textAlign: "right" }}></td>
                      <td class="total" style={{ textAlign: "right" }}></td>
                      <td class="total" style={{ textAlign: "right" }}></td>
                    </tr>
                  </tfoot>
                </OFMSUI.Table>
              </div>
            )}
          </OFMSUI.Container>
        </Form>
      </FormikProvider>
    </>
  );
};
export default NpiPhysicalProgressReport;
